var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u7D44\\u7E54\\u30DC\\u30BF\\u30F3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "office_building",
    "data-name": "office building",
    d: "M191.8,298.139h-8.434A1.378,1.378,0,0,0,182,299.55l.007,7.87h-7.352a1.4,1.4,0,0,0-1.4,1.418l-.044,9.579h12.5v-4.076a.468.468,0,0,1,.467-.471h2.816a.463.463,0,0,1,.465.471v4.076h3.754V299.55A1.408,1.408,0,0,0,191.8,298.139Zm-14.477,17.117a.428.428,0,0,1-.431.44H175.44a.436.436,0,0,1-.438-.44V313.8a.444.444,0,0,1,.438-.445h1.453a.436.436,0,0,1,.431.445Zm0-3.5a.427.427,0,0,1-.431.44H175.44a.435.435,0,0,1-.438-.44V310.32a.432.432,0,0,1,.438-.431h1.453a.423.423,0,0,1,.431.431Zm4.087,3.5a.434.434,0,0,1-.436.44h-1.46a.433.433,0,0,1-.436-.44V313.8a.441.441,0,0,1,.436-.445h1.46a.443.443,0,0,1,.436.445Zm0-3.5a.433.433,0,0,1-.436.44h-1.46a.432.432,0,0,1-.436-.44V310.32a.428.428,0,0,1,.436-.431h1.46a.43.43,0,0,1,.436.431Zm5.307-1.431a.429.429,0,0,1-.438.42h-1.462a.433.433,0,0,1-.447-.42v-1.462a.446.446,0,0,1,.447-.445h1.462a.443.443,0,0,1,.438.445Zm0-3.949a.439.439,0,0,1-.438.433h-1.462a.443.443,0,0,1-.447-.433v-1.462a.449.449,0,0,1,.447-.442h1.462a.445.445,0,0,1,.438.442Zm4.22,3.949a.419.419,0,0,1-.429.42h-1.458a.422.422,0,0,1-.442-.42v-1.462a.436.436,0,0,1,.442-.445h1.458a.433.433,0,0,1,.429.445Zm0-3.949a.429.429,0,0,1-.429.433h-1.458a.432.432,0,0,1-.442-.433v-1.462a.438.438,0,0,1,.442-.442h1.458a.435.435,0,0,1,.429.442Zm-4.22-3.829a.438.438,0,0,1-.438.433h-1.462a.441.441,0,0,1-.447-.433v-1.456a.447.447,0,0,1,.447-.44h1.462a.443.443,0,0,1,.438.44Zm4.22,0a.427.427,0,0,1-.429.433h-1.458a.431.431,0,0,1-.442-.433v-1.456a.436.436,0,0,1,.442-.44h1.458a.433.433,0,0,1,.429.44Z",
    transform: "translate(-170.709 -295.778)",
    fill: "#72383D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_859",
    "data-name": "\\u9577\\u65B9\\u5F62 859",
    width: 25,
    height: 25,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon_building.bd04b7683f4543b541caf9fa7408cf37.svg";
export { ForwardRef as ReactComponent };